export type WalletTransactionTypeForDisplay =
  | 'purchase'
  | 'reversal'
  | 'deposit'
  | 'gift'
  | 'refund'
  | 'adjustment'
  | 'other'

export function amountForInvoice(value: number, transactionType: string): number {
  const type = transactionType as WalletTransactionTypeForDisplay
  const isPositive = value >= 0

  switch (type) {
    case 'purchase':
      return -value
    case 'reversal':
      return isPositive ? -value : value
    case 'deposit':
      return isPositive ? value : value
    case 'gift':
      return isPositive ? value : value
    case 'refund':
      return isPositive ? value : value
    case 'adjustment':
    case 'other':
      return value
    default:
      return value
  }
}

/**
 * Format an effective tax rate (percent) for wallet invoice/list display.
 * Back-calculates from stored dollar amounts, rounds to 2dp max, trims trailing zeros.
 * We cap at 2dp because embedded US sales-tax tables store combined rates to two decimal
 * places (e.g. 7.5%, 8.88%, 6.25%); whole-percent rounding mislabels many of those.
 */
export function formatTaxRatePercent(
  taxCombined: number | null | undefined,
  amountExTax: number | null | undefined,
  amountIncTax?: number | null | undefined
): string {
  const tax = taxCombined ?? 0
  const exTax = amountExTax ?? (amountIncTax != null ? amountIncTax - tax : 0)

  if (!exTax) {
    return '0%'
  }

  const pct = (100 * tax) / exTax
  const rounded = Math.round(pct * 100) / 100
  return `${rounded.toFixed(2).replace(/\.?0+$/, '')}%`
}

export function amountForWalletList(value: number, transactionType: string): number {
  const type = transactionType as WalletTransactionTypeForDisplay
  switch (type) {
    case 'purchase':
      return value
    case 'reversal':
    case 'deposit':
    case 'gift':
    case 'refund':
    case 'adjustment':
    case 'other':
      return value
    default:
      return value
  }
}
